import { render, staticRenderFns } from "./LeakageCauseImpactedElementAgeQuestion.vue?vue&type=template&id=7b81988d&scoped=true"
import script from "./LeakageCauseImpactedElementAgeQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseImpactedElementAgeQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b81988d",
  null
  
)

export default component.exports